/* eslint-disable complexity */
/* eslint-disable no-nested-ternary */
import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";

import Modal from "../../shared/modal";
import CloseButton from "../../shared/icon-cross";
import Location from "./images/location.svg";
import { Button } from "@cars24/turbo-web/lib/button";
import { getPageSectionByName } from "../../../utils/helpers/get-cms-section";
import { LEAD_APPOINTMENT_STATUS } from "../../../constants/app-constants";
import { BottomSheet } from "@cars24/turbo-web/lib/bottom-sheet";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";

const DealerLocationModal = ({ isOpen, handleClose, onLoginClick, isLoggedIn, distance, dealerInfo, cmsConfig, leadAppointment, isMobile }) => {
    const isVerified = !!isLoggedIn;
    const { tokens } = useTokens();
    const pageSection = getPageSectionByName(cmsConfig.pageSections || cmsConfig?.data?.pageSections || [], "DEALER_LOCATION_MODAL");

    // Helper function to replace placeholders in CMS text
    const replacePlaceholders = (text, values) => {
        if (!text) return "";
        return text
            .replace(/\{name\}/g, values.name || "")
            .replace(/\{location\}/g, values.location || "")
            .replace(/\{distance\}/g, values.distance || "");
    };

    // Get CMS content or fallback to hardcoded values
    const getCmsContent = () => {
        const meta = pageSection?.meta;
        if (!meta) {
            return {
                title: isVerified ? dealerInfo.name : `The dealership is within ${distance} km from your location`,
                subTitle: isVerified ? dealerInfo.displayName : `Login to get dealership directions and contact details`,
                ctaText: (isVerified && leadAppointment?.status === LEAD_APPOINTMENT_STATUS.CONFIRM) ? "View Dealer" : (isVerified && leadAppointment?.status !== LEAD_APPOINTMENT_STATUS.CONFIRM) ? "Contact dealer" : "Login to view details"
            };
        }

        const contentType = isVerified ? meta.loggedIn : meta.loggedOut;
        const placeholderValues = {
            name: dealerInfo?.name || "",
            location: dealerInfo?.displayName || "",
            distance: distance || ""
        };

        return {
            title: replacePlaceholders(contentType?.heading, placeholderValues),
            subTitle: replacePlaceholders(contentType?.subHeading, placeholderValues),
            ctaText: (isVerified && leadAppointment?.status === LEAD_APPOINTMENT_STATUS.CONFIRM) ? "View Dealer" : (isVerified && leadAppointment?.status !== LEAD_APPOINTMENT_STATUS.CONFIRM) ? "Contact dealer" : "Login to view details"
        };
    };

    const { title, subTitle, ctaText } = getCmsContent();

    const imgSrc = isVerified ? (dealerInfo?.media?.[0]?.feUrl || dealerInfo?.media?.[0]?.url) : Location;

    const imageWrapperStyle = isMobile ? "styles.imageWrapperMobile" : "styles.imageWrapper";
    const mapImageStyle = (isMobile && isVerified) ? "styles.mapImageMobileVerfied" : (isMobile && !isVerified) ? "styles.mapImageMobile" : isVerified ? "styles.mapImageVerfied" : "styles.mapImage";
    const contentWrapStyle = isMobile ? "styles.contentWrapMobile" : "styles.contentWrap";
    const contentWrapInternalStyle = isMobile ? "styles.contentWrapMobileInternal" : "styles.contentWrapInternal";
    const content = (
        <>
            <div styleName={imageWrapperStyle}>
                <img styleName={mapImageStyle} src={imgSrc} alt="Dealership location" />
            </div>
            <div styleName={contentWrapInternalStyle}>
                <p styleName={"styles.heading"}>{title}</p>
                <p styleName={"styles.subHeading"}>{subTitle}</p>
            </div>
            <div styleName={"styles.buttonWrapper"}>
                <Button label={ctaText} onClick={onLoginClick} />
            </div>
        </>
    );

    if (isMobile) {
        return (
            <BottomSheet
                isOpen={isOpen}
                onClose={handleClose}
                height={"450px"}
                overlayColor={tokens.background_surface_overlay_primary}
                defaultPadding={false}
            >
                <div styleName={contentWrapStyle}>
                    {content}
                </div>
            </BottomSheet>
        );
    }

    return (
        <Modal isOpen={isOpen} close={handleClose}>
            <div styleName={"styles.wrapper"}>
                <div styleName={"styles.headerWrap"}>
                    <CloseButton type="grey" onClickHandler={handleClose} />
                </div>
                {content}
            </div>
        </Modal>
    );
};

DealerLocationModal.propTypes = {
    isOpen: PropTypes.bool,
    handleClose: PropTypes.func,
    onLoginClick: PropTypes.func,
    isLoggedIn: PropTypes.bool,
    distance: PropTypes.number,
    dealerInfo: PropTypes.any,
    cmsConfig: PropTypes.any,
    leadAppointment: PropTypes.any,
    isMobile: PropTypes.bool
};

export default DealerLocationModal;
